import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { theme } from './theme';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { LeadForm } from './components/LeadForm';
import { Footer } from './components/Footer';
import { QuoteProvider } from './components/QuoteDialog';
import { MobileStickyCTA } from './components/MobileStickyCTA';
export function App() {
  return <ThemeProvider theme={theme} data-id="element-0">
      <CssBaseline data-id="element-1" />
      <QuoteProvider data-id="element-2">
        <Box sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        // Leave room for the fixed mobile CTA bar so it never covers the footer
        pb: {
          xs: '76px',
          md: 0
        }
      }} data-id="element-3">
          <Header data-id="element-4" />
          <Box component="main" sx={{
          flexGrow: 1
        }} data-id="element-5">
            <Hero data-id="element-6" />
            <Services data-id="element-7" />
            <WhyChooseUs data-id="element-8" />
            <Gallery data-id="element-9" />
            <Testimonials data-id="element-10" />
            <LeadForm data-id="element-11" />
          </Box>
          <Footer data-id="element-12" />
        </Box>
        <MobileStickyCTA data-id="element-13" />
      </QuoteProvider>
    </ThemeProvider>;
}